// extracted by mini-css-extract-plugin
export default {"formSection":"contact-module--formSection--_jnOh"};